var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 1024,
    viewBox: "0 0 720 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_8571)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1024,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 -107L150 -70.75V1.75L87 38L24 1.75V-70.75L87 -107Z",
    fill: "url(#paint0_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5 -107L272 -70.75V1.75L209.5 38L147 1.75V-70.75L209.5 -107Z",
    fill: "url(#paint1_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5 -107L394 -70.75V1.75L331.5 38L269 1.75V-70.75L331.5 -107Z",
    fill: "url(#paint2_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5 -107L516 -70.75V1.75L453.5 38L391 1.75V-70.75L453.5 -107Z",
    fill: "url(#paint3_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.5 -107L638 -70.75V1.75L575.5 38L513 1.75V-70.75L575.5 -107Z",
    fill: "url(#paint4_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 -107L761 -70.75V1.75L698 38L635 1.75V-70.75L698 -107Z",
    fill: "url(#paint5_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 108L150 144.25V216.75L87 253L24 216.75V144.25L87 108Z",
    fill: "url(#paint6_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5 108L272 144.25V216.75L209.5 253L147 216.75V144.25L209.5 108Z",
    fill: "url(#paint7_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5 108L394 144.25V216.75L331.5 253L269 216.75V144.25L331.5 108Z",
    fill: "url(#paint8_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5 108L516 144.25V216.75L453.5 253L391 216.75V144.25L453.5 108Z",
    fill: "url(#paint9_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.5 108L638 144.25V216.75L575.5 253L513 216.75V144.25L575.5 108Z",
    fill: "url(#paint10_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 108L761 144.25V216.75L698 253L635 216.75V144.25L698 108Z",
    fill: "url(#paint11_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 108L24 144.5V217.5L-39 254L-102 217.5V144.5L-39 108Z",
    fill: "url(#paint12_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 -107L24 -70.75V1.75L-39 38L-102 1.75V-70.75L-39 -107Z",
    fill: "url(#paint13_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0L87 36.25V108.75L24.5 145L-38 108.75V36.25L24.5 0Z",
    fill: "url(#paint14_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 217L87 253.25V325.75L24.5 362L-38 325.75V253.25L24.5 217Z",
    fill: "url(#paint15_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 0L210 36.25V108.75L147.5 145L85 108.75V36.25L147.5 0Z",
    fill: "url(#paint16_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 0L333 36.25V108.75L270 145L207 108.75V36.25L270 0Z",
    fill: "url(#paint17_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5 0L455 36.25V108.75L392.5 145L330 108.75V36.25L392.5 0Z",
    fill: "url(#paint18_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.5 0L577 36.25V108.75L514.5 145L452 108.75V36.25L514.5 0Z",
    fill: "url(#paint19_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.5 0L699 36.25V108.75L636.5 145L574 108.75V36.25L636.5 0Z",
    fill: "url(#paint20_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.5 0L824 36.25V108.75L761.5 145L699 108.75V36.25L761.5 0Z",
    fill: "url(#paint21_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 217L210 253.25V325.75L147.5 362L85 325.75V253.25L147.5 217Z",
    fill: "url(#paint22_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 217L333 253.25V325.75L270 362L207 325.75V253.25L270 217Z",
    fill: "url(#paint23_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5 217L455 253.25V325.75L392.5 362L330 325.75V253.25L392.5 217Z",
    fill: "url(#paint24_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.5 217L577 253.25V325.75L514.5 362L452 325.75V253.25L514.5 217Z",
    fill: "url(#paint25_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.5 217L699 253.25V325.75L636.5 362L574 325.75V253.25L636.5 217Z",
    fill: "url(#paint26_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.5 217L824 253.25V325.75L761.5 362L699 325.75V253.25L761.5 217Z",
    fill: "url(#paint27_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 326L150 362.25V434.75L87 471L24 434.75V362.25L87 326Z",
    fill: "url(#paint28_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5 326L272 362.25V434.75L209.5 471L147 434.75V362.25L209.5 326Z",
    fill: "url(#paint29_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5 326L394 362.25V434.75L331.5 471L269 434.75V362.25L331.5 326Z",
    fill: "url(#paint30_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5 326L516 362.25V434.75L453.5 471L391 434.75V362.25L453.5 326Z",
    fill: "url(#paint31_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.5 326L638 362.25V434.75L575.5 471L513 434.75V362.25L575.5 326Z",
    fill: "url(#paint32_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 326L761 362.25V434.75L698 471L635 434.75V362.25L698 326Z",
    fill: "url(#paint33_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 541L150 577.25V649.75L87 686L24 649.75V577.25L87 541Z",
    fill: "url(#paint34_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5 541L272 577.25V649.75L209.5 686L147 649.75V577.25L209.5 541Z",
    fill: "url(#paint35_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5 541L394 577.25V649.75L331.5 686L269 649.75V577.25L331.5 541Z",
    fill: "url(#paint36_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5 541L516 577.25V649.75L453.5 686L391 649.75V577.25L453.5 541Z",
    fill: "url(#paint37_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.5 541L638 577.25V649.75L575.5 686L513 649.75V577.25L575.5 541Z",
    fill: "url(#paint38_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 541L761 577.25V649.75L698 686L635 649.75V577.25L698 541Z",
    fill: "url(#paint39_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 541L24 577.5V650.5L-39 687L-102 650.5V577.5L-39 541Z",
    fill: "url(#paint40_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 326L24 362.25V434.75L-39 471L-102 434.75V362.25L-39 326Z",
    fill: "url(#paint41_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 433L87 469.25V541.75L24.5 578L-38 541.75V469.25L24.5 433Z",
    fill: "url(#paint42_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 646L87 682.25V754.75L24.5 791L-38 754.75V682.25L24.5 646Z",
    fill: "url(#paint43_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 433L210 469.25V541.75L147.5 578L85 541.75V469.25L147.5 433Z",
    fill: "url(#paint44_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 433L333 469.25V541.75L270 578L207 541.75V469.25L270 433Z",
    fill: "url(#paint45_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5 433L455 469.25V541.75L392.5 578L330 541.75V469.25L392.5 433Z",
    fill: "url(#paint46_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.5 433L577 469.25V541.75L514.5 578L452 541.75V469.25L514.5 433Z",
    fill: "url(#paint47_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.5 433L699 469.25V541.75L636.5 578L574 541.75V469.25L636.5 433Z",
    fill: "url(#paint48_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.5 433L824 469.25V541.75L761.5 578L699 541.75V469.25L761.5 433Z",
    fill: "url(#paint49_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 650L210 686.25V758.75L147.5 795L85 758.75V686.25L147.5 650Z",
    fill: "url(#paint50_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 650L333 686.25V758.75L270 795L207 758.75V686.25L270 650Z",
    fill: "url(#paint51_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5 650L455 686.25V758.75L392.5 795L330 758.75V686.25L392.5 650Z",
    fill: "url(#paint52_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.5 650L577 686.25V758.75L514.5 795L452 758.75V686.25L514.5 650Z",
    fill: "url(#paint53_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.5 650L699 686.25V758.75L636.5 795L574 758.75V686.25L636.5 650Z",
    fill: "url(#paint54_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.5 650L824 686.25V758.75L761.5 795L699 758.75V686.25L761.5 650Z",
    fill: "url(#paint55_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 755L148 791.25V863.75L85 900L22 863.75V791.25L85 755Z",
    fill: "url(#paint56_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.5 755L270 791.25V863.75L207.5 900L145 863.75V791.25L207.5 755Z",
    fill: "url(#paint57_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.5 755L392 791.25V863.75L329.5 900L267 863.75V791.25L329.5 755Z",
    fill: "url(#paint58_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5 755L514 791.25V863.75L451.5 900L389 863.75V791.25L451.5 755Z",
    fill: "url(#paint59_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.5 755L636 791.25V863.75L573.5 900L511 863.75V791.25L573.5 755Z",
    fill: "url(#paint60_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696 755L759 791.25V863.75L696 900L633 863.75V791.25L696 755Z",
    fill: "url(#paint61_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 970L148 1006.25V1078.75L85 1115L22 1078.75V1006.25L85 970Z",
    fill: "url(#paint62_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.5 970L270 1006.25V1078.75L207.5 1115L145 1078.75V1006.25L207.5 970Z",
    fill: "url(#paint63_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.5 970L392 1006.25V1078.75L329.5 1115L267 1078.75V1006.25L329.5 970Z",
    fill: "url(#paint64_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5 970L514 1006.25V1078.75L451.5 1115L389 1078.75V1006.25L451.5 970Z",
    fill: "url(#paint65_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.5 970L636 1006.25V1078.75L573.5 1115L511 1078.75V1006.25L573.5 970Z",
    fill: "url(#paint66_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696 970L759 1006.25V1078.75L696 1115L633 1078.75V1006.25L696 970Z",
    fill: "url(#paint67_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 970L22 1006.5V1079.5L-41 1116L-104 1079.5V1006.5L-41 970Z",
    fill: "url(#paint68_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 755L22 791.25V863.75L-41 900L-104 863.75V791.25L-41 755Z",
    fill: "url(#paint69_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 862L85 898.25V970.75L22.5 1007L-40 970.75V898.25L22.5 862Z",
    fill: "url(#paint70_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 862L208 898.25V970.75L145.5 1007L83 970.75V898.25L145.5 862Z",
    fill: "url(#paint71_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 862L331 898.25V970.75L268 1007L205 970.75V898.25L268 862Z",
    fill: "url(#paint72_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.5 862L453 898.25V970.75L390.5 1007L328 970.75V898.25L390.5 862Z",
    fill: "url(#paint73_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.5 862L575 898.25V970.75L512.5 1007L450 970.75V898.25L512.5 862Z",
    fill: "url(#paint74_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.5 862L697 898.25V970.75L634.5 1007L572 970.75V898.25L634.5 862Z",
    fill: "url(#paint75_linear_9_8571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 862L822 898.25V970.75L759.5 1007L697 970.75V898.25L759.5 862Z",
    fill: "url(#paint76_linear_9_8571)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_8571",
    x1: 118.826,
    y1: -90.3854,
    x2: 55.4972,
    y2: 20.0606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_8571",
    x1: 241.074,
    y1: -90.3854,
    x2: 177.491,
    y2: 19.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_8571",
    x1: 363.074,
    y1: -90.3854,
    x2: 299.491,
    y2: 19.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_8571",
    x1: 485.074,
    y1: -90.3854,
    x2: 421.491,
    y2: 19.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_8571",
    x1: 607.074,
    y1: -90.3854,
    x2: 543.491,
    y2: 19.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_8571",
    x1: 729.826,
    y1: -90.3854,
    x2: 666.497,
    y2: 20.0606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9_8571",
    x1: 118.826,
    y1: 124.615,
    x2: 55.4972,
    y2: 235.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9_8571",
    x1: 241.074,
    y1: 124.615,
    x2: 177.491,
    y2: 234.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9_8571",
    x1: 363.074,
    y1: 124.615,
    x2: 299.491,
    y2: 234.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9_8571",
    x1: 485.074,
    y1: 124.615,
    x2: 421.491,
    y2: 234.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9_8571",
    x1: 607.074,
    y1: 124.615,
    x2: 543.491,
    y2: 234.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9_8571",
    x1: 729.826,
    y1: 124.615,
    x2: 666.497,
    y2: 235.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9_8571",
    x1: -7.17356,
    y1: 124.729,
    x2: -71.1602,
    y2: 235.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9_8571",
    x1: -7.17356,
    y1: -90.3854,
    x2: -70.5028,
    y2: 20.0606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9_8571",
    x1: 56.0739,
    y1: 16.6146,
    x2: -7.50932,
    y2: 126.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9_8571",
    x1: 56.0739,
    y1: 233.615,
    x2: -7.50932,
    y2: 343.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9_8571",
    x1: 179.074,
    y1: 16.6146,
    x2: 115.491,
    y2: 126.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9_8571",
    x1: 301.826,
    y1: 16.6146,
    x2: 238.497,
    y2: 127.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9_8571",
    x1: 424.074,
    y1: 16.6146,
    x2: 360.491,
    y2: 126.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9_8571",
    x1: 546.074,
    y1: 16.6146,
    x2: 482.491,
    y2: 126.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9_8571",
    x1: 668.074,
    y1: 16.6146,
    x2: 604.491,
    y2: 126.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9_8571",
    x1: 793.074,
    y1: 16.6146,
    x2: 729.491,
    y2: 126.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9_8571",
    x1: 179.074,
    y1: 233.615,
    x2: 115.491,
    y2: 343.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9_8571",
    x1: 301.826,
    y1: 233.615,
    x2: 238.497,
    y2: 344.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9_8571",
    x1: 424.074,
    y1: 233.615,
    x2: 360.491,
    y2: 343.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9_8571",
    x1: 546.074,
    y1: 233.615,
    x2: 482.491,
    y2: 343.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9_8571",
    x1: 668.074,
    y1: 233.615,
    x2: 604.491,
    y2: 343.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_9_8571",
    x1: 793.074,
    y1: 233.615,
    x2: 729.491,
    y2: 343.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_9_8571",
    x1: 118.826,
    y1: 342.615,
    x2: 55.4972,
    y2: 453.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_9_8571",
    x1: 241.074,
    y1: 342.615,
    x2: 177.491,
    y2: 452.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_9_8571",
    x1: 363.074,
    y1: 342.615,
    x2: 299.491,
    y2: 452.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_9_8571",
    x1: 485.074,
    y1: 342.615,
    x2: 421.491,
    y2: 452.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_9_8571",
    x1: 607.074,
    y1: 342.615,
    x2: 543.491,
    y2: 452.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_9_8571",
    x1: 729.826,
    y1: 342.615,
    x2: 666.497,
    y2: 453.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_9_8571",
    x1: 118.826,
    y1: 557.615,
    x2: 55.4972,
    y2: 668.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_9_8571",
    x1: 241.074,
    y1: 557.615,
    x2: 177.491,
    y2: 667.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_9_8571",
    x1: 363.074,
    y1: 557.615,
    x2: 299.491,
    y2: 667.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_9_8571",
    x1: 485.074,
    y1: 557.615,
    x2: 421.491,
    y2: 667.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_9_8571",
    x1: 607.074,
    y1: 557.615,
    x2: 543.491,
    y2: 667.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_9_8571",
    x1: 729.826,
    y1: 557.615,
    x2: 666.497,
    y2: 668.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_9_8571",
    x1: -7.17356,
    y1: 557.729,
    x2: -71.1602,
    y2: 668.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_9_8571",
    x1: -7.17356,
    y1: 342.615,
    x2: -70.5028,
    y2: 453.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_9_8571",
    x1: 56.0739,
    y1: 449.615,
    x2: -7.50932,
    y2: 559.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_9_8571",
    x1: 56.0739,
    y1: 662.615,
    x2: -7.50932,
    y2: 772.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_9_8571",
    x1: 179.074,
    y1: 449.615,
    x2: 115.491,
    y2: 559.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_9_8571",
    x1: 301.826,
    y1: 449.615,
    x2: 238.497,
    y2: 560.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_9_8571",
    x1: 424.074,
    y1: 449.615,
    x2: 360.491,
    y2: 559.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_9_8571",
    x1: 546.074,
    y1: 449.615,
    x2: 482.491,
    y2: 559.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_9_8571",
    x1: 668.074,
    y1: 449.615,
    x2: 604.491,
    y2: 559.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_9_8571",
    x1: 793.074,
    y1: 449.615,
    x2: 729.491,
    y2: 559.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_9_8571",
    x1: 179.074,
    y1: 666.615,
    x2: 115.491,
    y2: 776.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_9_8571",
    x1: 301.826,
    y1: 666.615,
    x2: 238.497,
    y2: 777.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_9_8571",
    x1: 424.074,
    y1: 666.615,
    x2: 360.491,
    y2: 776.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_9_8571",
    x1: 546.074,
    y1: 666.615,
    x2: 482.491,
    y2: 776.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_9_8571",
    x1: 668.074,
    y1: 666.615,
    x2: 604.491,
    y2: 776.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_9_8571",
    x1: 793.074,
    y1: 666.615,
    x2: 729.491,
    y2: 776.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_9_8571",
    x1: 116.826,
    y1: 771.615,
    x2: 53.4972,
    y2: 882.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_9_8571",
    x1: 239.074,
    y1: 771.615,
    x2: 175.491,
    y2: 881.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_9_8571",
    x1: 361.074,
    y1: 771.615,
    x2: 297.491,
    y2: 881.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_9_8571",
    x1: 483.074,
    y1: 771.615,
    x2: 419.491,
    y2: 881.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_9_8571",
    x1: 605.074,
    y1: 771.615,
    x2: 541.491,
    y2: 881.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_9_8571",
    x1: 727.826,
    y1: 771.615,
    x2: 664.497,
    y2: 882.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_9_8571",
    x1: 116.826,
    y1: 986.615,
    x2: 53.4972,
    y2: 1097.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_9_8571",
    x1: 239.074,
    y1: 986.615,
    x2: 175.491,
    y2: 1096.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_9_8571",
    x1: 361.074,
    y1: 986.615,
    x2: 297.491,
    y2: 1096.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_9_8571",
    x1: 483.074,
    y1: 986.615,
    x2: 419.491,
    y2: 1096.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_9_8571",
    x1: 605.074,
    y1: 986.615,
    x2: 541.491,
    y2: 1096.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_9_8571",
    x1: 727.826,
    y1: 986.615,
    x2: 664.497,
    y2: 1097.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_9_8571",
    x1: -9.17356,
    y1: 986.729,
    x2: -73.1602,
    y2: 1097.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_9_8571",
    x1: -9.17356,
    y1: 771.615,
    x2: -72.5028,
    y2: 882.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_9_8571",
    x1: 54.0739,
    y1: 878.615,
    x2: -9.50932,
    y2: 988.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_9_8571",
    x1: 177.074,
    y1: 878.615,
    x2: 113.491,
    y2: 988.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_9_8571",
    x1: 299.826,
    y1: 878.615,
    x2: 236.497,
    y2: 989.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_9_8571",
    x1: 422.074,
    y1: 878.615,
    x2: 358.491,
    y2: 988.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_9_8571",
    x1: 544.074,
    y1: 878.615,
    x2: 480.491,
    y2: 988.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_9_8571",
    x1: 666.074,
    y1: 878.615,
    x2: 602.491,
    y2: 988.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_9_8571",
    x1: 791.074,
    y1: 878.615,
    x2: 727.491,
    y2: 988.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_8571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCover);
export default __webpack_public_path__ + "static/media/login-cover.1f54053cdfeac415f30cd4a30b849095.svg";
export { ForwardRef as ReactComponent };